import axios from 'axios';
import AppUrls from '../config/AppUrls';
import store from '../store';
import { logout } from '../redux/actions/AuthActions';

class ApiService {
  constructor() {
    const api = this;
    api.instance = axios.create({
      baseURL: AppUrls.api.baseUrl,
      withCredentials: true,
    });

    api.instance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response && error.response.status && api.logoutStatus.includes(error.response.status)) {
          localStorage.clear();
          store.dispatch(logout());
        }
        return Promise.reject(error);
      }
    );
  }

  get logoutStatus() {
    return [401];
  }

  request(options) {
    return this.instance.request(options);
  }

  get(url, params = {}) {
    if (!Object.keys(params).length) {
      return this.instance.get(url);
    }

    const qs = this.queryString(params);
    const join = url.includes('?') ? '&' : '?';
    return this.instance.get(url + join + qs);
  }

  post(url, params) {
    return this.instance.post(url, params);
  }

  put(url, params = {}, queryParams = {}) {
    let fullUrl = url;

    if (Object.keys(queryParams).length > 0) {
      const qs = this.queryString(queryParams);
      const join = url.includes('?') ? '&' : '?';
      fullUrl = url + join + qs;
    }
    return this.instance.put(fullUrl, params);
  }

  delete(url, params) {
    return this.instance.delete(url, params);
  }

  postWithFiles = (url, params) => {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    const file = params.file;
    delete params.file;
    const data = new FormData();
    data.append('file', file);
    if (Object.keys(params).length) {
      const request = new Blob([JSON.stringify(params)], {
        type: 'application/json',
      });
      data.append('request', request);
    }

    return this.instance.post(url, data, options);
  };

  queryString = (params) =>
    Object.keys(params)
      .map((key) => {
        if (params[key] instanceof Array) {
          return params[key].map((value) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
      })
      .join('&');
}

const apiServiceInstance = new ApiService();

export default apiServiceInstance;
